





















import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteShop, QueryShopList, UpdateShopStatus,UpdateShopPlatformClose } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditShopDialog from './EditShopDialog.vue'
import { ShopAuditStatusFormat, ShopStatusFormat,PlatformCloseFormat,PriceFormat } from '@/utils/tyepconvert'
import CreatetNewShopDialog from './components/CreatetNewShopDialog.vue'
import constan from '@/utils/constant'
import ShopWealhRecordDialog from './components/ShopWealhRecordDialog.vue'
import ChangeBankCardDialog from './components/ChangeBankCardDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditShopDialog,
    CreatetNewShopDialog,
    ShopWealhRecordDialog,
    ChangeBankCardDialog
  },
})
export default class VideoList extends Vue {
  private PriceFormat = PriceFormat
  private queryParam = {
    startRow: 1,
    limit: 10,
    includeSpecialRefundEstimate: true,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private activeMenu = "ALL"

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '店铺名称', param: 'name' },
    { title: '统一社会信用代码', param: 'creditCode' },
    // { title: '状态', param: 'status', type: 'select',selectData: constan.ShopStatus },
    { title: '审核状态', param: 'auditStatus', type: 'select',selectData: constan.ShopAuditStatus },
    { title: '是否闭店', param: 'platformClose', type: 'select',selectData: constan.PlatformClose },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建店铺', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺ID', param: 'id' },
    // { title: '汇付商户号', param: 'huifuMerchantNo' },
    // { title: '入网状态', param: 'registMerchantStatus' , formatter: (v:any)=>v?'已入网':'未入网'},
    { title: 'logo', param: 'logo', type: 'image' },
    { title: '店铺名称', param: 'name' },
    { title: '商家类型', param: 'sjtype', formatter: this.sjtypeFormat },
    { title: '评分', param: 'score', formatter: (v: any) => v ? v.toFixed(1) : '5.0' },
    { title: '营业执照', param: 'businessLicense',type: 'image' },
    { title: '统一社会信用代码', param: 'creditCode' },
    { title: '联系人', param: 'contactsName' },
    { title: '联系人电话', param: 'contactsPhone' },
    { title: '余额', param: 'shopWealth.balance', formatter: PriceFormat },
    { title: '待结算金额', param: 'shopWealth.waitSettlementAmount', formatter: PriceFormat },
    { title: '提现冻结金额', param: 'shopWealth.withdrawIngAmount', formatter: PriceFormat },
    { title: '已提现金额', param: 'shopWealth.withdrawSuccessAmount', formatter: PriceFormat },
    { title: '预估退款(元)', param: 'specialRefundEstimate.totalRefundFen', width: 110, formatter: this.formatEstimateRefundFen },
    { title: '预估扣店(元)', param: 'specialRefundEstimate.totalShopDeductFen', width: 110, formatter: this.formatEstimateDeductFen },
    { title: '预估扣后余额(元)', param: 'specialRefundEstimate.estimatedBalanceAfterDeductFen', width: 120, formatter: this.formatEstimateBalanceAfter },
    { title: '退绿豆(颗)', param: 'specialRefundEstimate.estimatedMungBeanQty', width: 90, formatter: this.formatEstimateMung },
    { title: '预估PV亏损(元)', param: 'specialRefundEstimate.estimatedPvLossYuan', width: 110, formatter: this.formatEstimatePv },
    { title: '退款人数', param: 'specialRefundEstimate.estimatedRefundUserCount', width: 100, formatter: this.formatEstimateUsers },
    { title: '已提现占用单', param: 'specialRefundEstimate.skipWithdrawOrders', width: 200, overflow: true, formatter: this.formatSkipWithdrawOrders },
    { title: '总收益', param: 'shopWealth.totalIncome' , formatter: PriceFormat},
    { title: '状态', param: 'status' , formatter: ShopStatusFormat},
    { title: '是否闭店', param: 'platformClose' , formatter: PlatformCloseFormat},
    { title: '审核状态', param: 'auditStatus' , formatter: ShopAuditStatusFormat},
    { title: '拒绝原因', param: 'auditRejectMsg' , overflow: true,hide: this.activeMenu != 'auditReject'},
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 280,
      fixed: 'right',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        { title: '查看店铺流水', click: this.openWealhRecord },
        {
          title: '特殊关单退绿豆',
          type: 'warning',
          click: this.goSpecialRefund,
          show: (data: any) => data.id != 100009,
        },
        {
          title: '营业',
          click: this.updateOpenStatus,
          show: function (data) {
            return data.status != 1
          },
        },
        {
          title: '休息',
          click: this.updateCloseStatus,
          show: function (data) {
            return data.status == 1
          },
        },
        {
          title: '强制闭店',
          click: this.updatePlatformClose,
          show: function (data) {
            return data.platformClose == false
          },
        },
        {
          title: '解除闭店',
          click: this.updateOpenPlatformClose,
          show: function (data) {
            return data.platformClose == true
          },
        },
        {
          title: '变更银行卡',
          click: this.changeBankCardHandle,
          show: function (data) {
            return data.auditStatus == 2
          },
        },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  // 格式化商家类型
  private sjtypeFormat(value: number) {
    if (!value || value === 0) {
      return '普通商家'
    }
    const types: string[] = []
    if (value & 1) { // 包含精选商家
      types.push('精选商家')
    }
    if (value & 2) { // 包含新商家
      types.push('新商家')
    }
    return types.length > 0 ? types.join(' + ') : '普通商家'
  }

  private formatEstimateMung(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return est?.hint || '-'
    return est.estimatedMungBeanQty != null ? String(est.estimatedMungBeanQty) : '0'
  }

  private formatEstimateRefundFen(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return '-'
    return PriceFormat(est.totalRefundFen || 0)
  }

  private formatEstimateDeductFen(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return '-'
    return PriceFormat(est.totalShopDeductFen || 0)
  }

  private formatEstimateBalanceAfter(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return '-'
    return PriceFormat(est.estimatedBalanceAfterDeductFen || 0)
  }

  private formatEstimatePv(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return '-'
    return est.estimatedPvLossYuan != null ? String(est.estimatedPvLossYuan) : '0'
  }

  private formatEstimateUsers(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return '-'
    const n = est.estimatedRefundUserCount
    const orders = est.refundableOrderCount
    if (n == null) return '0'
    return orders != null && orders > 0 ? `${n}（${orders}单）` : String(n)
  }

  private formatSkipWithdrawOrders(_v: any, row: any) {
    const est = row.specialRefundEstimate
    if (!est || est.applicable === false) return '-'
    const list = est.skipWithdrawOrders
    if (!list || !list.length) return '-'
    return list.map((o: any) => {
      if (!o || !o.orderCode) return ''
      if (o.withdrawOccupiedPartial) {
        const occupied = o.withdrawOccupiedFen != null ? this.PriceFormat(o.withdrawOccupiedFen) : ''
        const settlement = o.settlementAmountFen != null ? this.PriceFormat(o.settlementAmountFen) : ''
        return `${o.orderCode}[部分占用${occupied}/${settlement}]`
      }
      const occupied = o.withdrawOccupiedFen
      const settlement = o.settlementAmountFen
      if (occupied != null && settlement != null && occupied < settlement) {
        return `${o.orderCode}[部分占用${this.PriceFormat(occupied)}/${this.PriceFormat(settlement)}]`
      }
      return o.orderCode
    }).filter(Boolean).join('、')
  }

  private buildListFilterParam() {
    const param: any = { ...this.queryParam }
    delete param.startRow
    delete param.limit
    delete param.includeSpecialRefundEstimate
    if (this.activeMenu == 'wait') {
      param.auditStatus = 0
    } else if (this.activeMenu == 'audit') {
      param.auditStatusIn = [1, 4]
    } else if (this.activeMenu == 'auditReject') {
      param.auditStatus = 3
    } else if (this.activeMenu == 'open') {
      param.auditStatus = 2
      param.status = 1
    } else if (this.activeMenu == 'close') {
      param.auditStatus = 2
      param.status = 0
    }
    return param
  }

  private openCreateVideo() {
    const d = this.$refs.CreatetNewShopDialog as CreatetNewShopDialog
    d.open()
  }

  private changeBankCardHandle(data:any){
    const d = this.$refs.ChangeBankCardDialog as ChangeBankCardDialog
    d.open(data)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteShop({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  private async updateOpenStatus(data: any) {
    await UpdateShopStatus({
      id: data.id,
      status: 1,
    })
    this.loadData()
  }
  private async updateCloseStatus(data: any) {
    await UpdateShopStatus({
      id: data.id,
      status: 0,
    })
    this.loadData()
  }

  private updatePlatformClose(data: any){

    this.$prompt("是否强制关闭店铺？", '提示', {
      confirmButtonText: '清空',
      cancelButtonText: '取消',
      type: 'warning'
    }).then((md:any) => {
      UpdateShopPlatformClose({
        id: data.id,
        platformClose: true,
        platformCloseMsg: md.value,
      }).then(res=>{
        this.$message.success("已关闭店铺")
        this.loadData()
      })
    })
  }
  private updateOpenPlatformClose(data: any){
    this.$confirm("是否开启店铺？", '提示', {
      confirmButtonText: '清空',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      UpdateShopPlatformClose({
        id: data.id,
        platformClose: false,
      }).then(res=>{
        this.$message.success("已开启店铺")
        this.loadData()
      })
    })
  }

  public openEditVideo(data: any) {
    const d = this.$refs.EditShopDialog as EditShopDialog
    d.open(data, true)
  }
  public openWealhRecord(data: any) {
    const d = this.$refs.ShopWealhRecordDialog as any
    d.open(data)
  }

  private goSpecialRefund(data: any) {
    if (!data || !data.id) return
    if (Number(data.id) === 100009) {
      Message.warning('平台直营店 100009 不支持特殊关单退绿豆')
      return
    }
    this.$router.push({ path: '/shopSpecialRefund', query: { shopId: String(data.id) } })
  }

  //。选择菜单
  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    const ts = this.tableHander.filter(e=>e.param == 'auditRejectMsg')
    if(e == 'auditReject'){
      ts[0].hide = false
    } else {
      ts[0].hide = true
    }
    this.search()
  }

  public async loadData() {
    const param: any = { ...this.buildListFilterParam() }
    param.includeSpecialRefundEstimate = true
    param.startRow = (this.tableCurrntPage - 1) * (this.queryParam.limit || 12)
    param.limit = this.queryParam.limit || 12
    const result = await QueryShopList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
